<div *ngIf="templateEmail" class="formgrid grid w-full pt-4">
    <div class="field col-12 mt-2">
        <p-floatLabel>
            <input id="subject" pInputText [(ngModel)]="templateEmail.templateName" width="100%" [style]="{'width': '100%'}"/>
            <label for="subject">Template Name</label>
        </p-floatLabel>
    </div>
    <div class="field col-12 mt-2">
        <p-floatLabel>
            <input id="subject" pInputText [(ngModel)]="templateEmail.subject" width="100%" [style]="{'width': '100%'}"/>
            <label for="subject">Subject</label>
        </p-floatLabel>
    </div>
    <div class="field col-12">
        <p-editor [(ngModel)]="templateEmail.body" [style]="{ height: '250px' }" />     
    </div>
</div>
<div class="flex mt-2 w-full justify-content-center" >
    <p-buttonGroup>
        <p-button label="Save" icon="pi pi-save" [disabled]="!allowSave()" (onClick)="saveButtonPressed()"></p-button>
        <p-button label="Cancel" icon="pi pi-times" severity="danger" (onClick)="cancelButtonPressed();" ></p-button>
    </p-buttonGroup>
</div>
